/* pl-video-modal — comportamento do modal de video da PDP (Plenitude).

   PROBLEMA 1 — custo. O snippet da agencia (iframe-yt-video.liquid) escrevia o
   iframe com src preenchido e loading="lazy". Medido na PDP ao vivo: o request
   para youtube.com/embed/<id> SAI NO LOAD DA PAGINA, antes de qualquer clique
   (379ms no celular, 1129ms no desktop). O lazy nao segura iframe de elemento
   fixo. Resultado: toda PDP com video pagava o embed inteiro da YouTube,
   inclusive para quem nunca abria o video — justo o oposto do que o
   PERFORMANCE.md persegue.
   Aqui e facade: o iframe so nasce quando o modal abre, ja com autoplay=1.

   PROBLEMA 2 — proporcao. Os videos de produto sao mistos: o canal tem Shorts
   (9:16) e videos normais (16:9). O frame era 16:9 fixo, entao o Short ficava
   com 106px de largura no celular e o resto era o borrao lateral da YouTube.
   Deteccao: i.ytimg.com/vi/<id>/oardefault.jpg ("original aspect ratio") volta
   as dimensoes reais quando o video e vertical. Para 16:9 volta 404 — mas com
   um JPEG cinza de 120x90 no corpo, entao NAO da para confiar no onerror (ver
   probe() abaixo). Uma unica imagem serve de DETECTOR e de POSTER — e o poster
   e o que mata o retangulo branco enquanto o player da YouTube nao pinta.

   O abrir/fechar continua sendo do bundle da agencia (modal-button ->
   modal-component). Este arquivo so observa a classe .open; fechar tambem e
   delegado ao botao da agencia, para nao duplicar maquina de estado. */

(function () {
  'use strict';

  var AR_HORIZONTAL = 1.7778; // 16:9
  var idle =
    window.requestIdleCallback ||
    function (fn) {
      return window.setTimeout(fn, 1500);
    };

  function init(modal) {
    if (modal.dataset.plVideoReady === '1') return;
    modal.dataset.plVideoReady = '1';

    var frame = modal.querySelector('[data-pl-video-frame]');
    var poster = modal.querySelector('.pl-video-modal__poster');
    var card = modal.querySelector('.pl-video-modal__card');
    var closeBtn = modal.querySelector('.pl-video-modal__close');
    var videoId = frame && frame.dataset.videoId;
    if (!frame || !videoId) return;

    var iframe = null;
    var probed = false;
    var triggerEl = null;
    var prevOverflow = '';
    var prevPadding = '';

    /* ---------- proporcao + poster (1 requisicao, fora do caminho critico) ---------- */

    function probe() {
      if (probed) return;
      probed = true;

      function usarHorizontal() {
        setRatio(AR_HORIZONTAL);
        poster.src = 'https://i.ytimg.com/vi/' + videoId + '/maxresdefault.jpg';
      }

      var img = new Image();
      img.onload = function () {
        var w = img.naturalWidth;
        var h = img.naturalHeight;

        // ARMADILHA: quando oardefault nao existe, o i.ytimg responde 404 mas
        // com um JPEG cinza de 120x90 no CORPO — entao onload dispara igual e
        // entregaria 4:3. Visto num video 16:9 real (Jgmm_uVnGxY): a proporcao
        // saiu 1.3333. So aceito oardefault quando ele PROVA que o video e
        // vertical; qualquer outra coisa cai no 16:9.
        if (h > w && w > 120) {
          setRatio(w / h);
          poster.src = img.src; // ja esta no cache
          return;
        }
        usarHorizontal();
      };
      img.onerror = usarHorizontal;
      img.src = 'https://i.ytimg.com/vi/' + videoId + '/oardefault.jpg';
    }

    function setRatio(ratio) {
      if (!ratio || !isFinite(ratio)) return;
      modal.style.setProperty('--pl-video-ar', ratio.toFixed(4));
    }

    idle(probe);

    /* ---------- o player so aparece quando o VIDEO comeca ---------- */

    // PROBLEMA 3 — audio antes da imagem (Diogo, 29/09, Devocional Moldadas: "a
    // musica comeca bem antes e depois de 5 a 7 segundos o video comecou a rolar").
    // O iframe fica invisivel (poster + anel por cima) e antes aparecia no `load`
    // do iframe. So que o `load` espera TODOS os recursos da pagina da YouTube
    // (rastreadores, anuncios): em rede lenta ou com bloqueador ele chega segundos
    // DEPOIS de o autoplay ja estar tocando, e a pessoa ouvia a musica olhando o
    // poster. Medido na PDP: player pronto 0,87 s · load 1,01 s · tocando 2,77 s —
    // o load nao tem relacao com o play.
    // O sinal certo vem do proprio player (enablejsapi=1 + origin): mandamos
    // {event:'listening'} ate ele responder; dai ele avisa o estado a cada troca.
    var revealed = false;
    var heard = false;
    var timers = [];

    function clearTimers() {
      timers.forEach(function (t) {
        window.clearTimeout(t);
        window.clearInterval(t);
      });
      timers = [];
    }

    function reveal() {
      if (revealed) return;
      revealed = true;
      frame.classList.add('is-playing');
      clearTimers();
    }

    function onMessage(event) {
      if (!iframe || event.source !== iframe.contentWindow) return;
      var data = event.data;
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (e) {
          return;
        }
      }
      if (!data || !data.event) return;
      heard = true;
      var state;
      if (data.event === 'onStateChange') state = data.info;
      else if (data.event === 'infoDelivery' && data.info) state = data.info.playerState;
      // 1 = tocando. 2 (pausado), 5 (pronto sem tocar) e 0 (fim) = o autoplay nao
      // rolou (navegador barrou): mostra o player para a pessoa apertar o play.
      if (state === 1 || state === 2 || state === 5 || state === 0) reveal();
      // pronto e ainda sem tocar depois de 4 s (rede lenta ou autoplay barrado sem
      // avisar estado): mostra o player com os controles da YouTube
      if (data.event === 'onReady') timers.push(window.setTimeout(reveal, 4000));
    }

    function listen() {
      // aperto de mao do embed: repete ate o player responder (no maximo 10 s)
      var tries = 0;
      var handshake = window.setInterval(function () {
        if (heard || revealed || !iframe || ++tries > 50) {
          window.clearInterval(handshake);
          return;
        }
        try {
          iframe.contentWindow.postMessage(
            JSON.stringify({ event: 'listening', id: videoId, channel: 'widget' }),
            'https://www.youtube.com'
          );
        } catch (e) {
          /* o iframe ainda esta em about:blank — a proxima volta pega */
        }
      }, 200);
      timers.push(handshake);
      // se o player nunca responder (protocolo mudou), volta ao comportamento
      // antigo — aparece 1,5 s depois do load; e, em ultimo caso, aos 8 s
      iframe.addEventListener(
        'load',
        function () {
          timers.push(
            window.setTimeout(function () {
              if (!heard) reveal();
            }, 1500)
          );
        },
        { once: true }
      );
      timers.push(window.setTimeout(reveal, 8000));
    }

    /* ---------- iframe so quando abre ---------- */

    function mount() {
      if (iframe) return;
      probe(); // caso o usuario clique antes do idle

      var params = [
        'autoplay=1',
        'playsinline=1', // sem isso o iOS joga no player nativo em tela cheia
        'rel=0',
        'modestbranding=1',
        'enablejsapi=1',
        'origin=' + encodeURIComponent(window.location.origin) // faltava, e a YouTube reclamava
      ].join('&');

      iframe = document.createElement('iframe');
      iframe.className = 'pl-video-modal__iframe';
      iframe.title = frame.dataset.videoTitle || 'Video do produto';
      iframe.allow =
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.setAttribute('allowfullscreen', '');
      revealed = false;
      heard = false;
      window.addEventListener('message', onMessage);
      iframe.src = 'https://www.youtube.com/embed/' + videoId + '?' + params;
      frame.appendChild(iframe);
      listen();
    }

    function unmount() {
      window.removeEventListener('message', onMessage);
      clearTimers();
      // remover e o que PARA o video: sem isso o audio segue tocando fechado
      if (iframe) {
        iframe.remove();
        iframe = null;
      }
      frame.classList.remove('is-playing');
    }

    /* ---------- travar o fundo ---------- */

    function lockScroll() {
      var root = document.documentElement;
      var barWidth = window.innerWidth - root.clientWidth;
      prevOverflow = root.style.overflow;
      prevPadding = root.style.paddingRight;
      root.style.overflow = 'hidden';
      // compensa a barra de rolagem, senao a pagina inteira pula ao abrir
      if (barWidth > 0) root.style.paddingRight = barWidth + 'px';
    }

    function unlockScroll() {
      var root = document.documentElement;
      root.style.overflow = prevOverflow;
      root.style.paddingRight = prevPadding;
    }

    /* ---------- teclado e foco ---------- */

    function requestClose() {
      if (closeBtn) closeBtn.click(); // fechar continua sendo do bundle
    }

    function onKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        requestClose();
        return;
      }
      if (event.key !== 'Tab' || !card) return;

      // prende o Tab dentro do card
      var focusables = card.querySelectorAll(
        'a[href], button, iframe, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    // modal-button e custom element: com role=button o Enter/Espaco nao vira
    // click sozinho como viraria num <button> nativo
    if (closeBtn) {
      closeBtn.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
          event.preventDefault();
          closeBtn.click();
        }
      });
    }

    /* ---------- reage ao open/close do bundle ---------- */

    function onOpen() {
      // o gatilho e o botao que o carrossel da agencia cria na galeria. Nao da
      // para usar document.activeElement: modal-button nao e focavel, entao
      // clicar nele deixa o foco no body e o retorno de foco viraria no-op.
      triggerEl =
        document.querySelector(
          'modal-button[data-modal-id="' + modal.id + '"][data-behavior="open"]'
        ) || null;
      mount();
      lockScroll();
      document.addEventListener('keydown', onKeydown);
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }

    function onClose() {
      unmount();
      unlockScroll();
      document.removeEventListener('keydown', onKeydown);
      if (triggerEl) {
        // tabindex="-1" torna focavel por script SEM entrar na ordem do Tab
        if (!triggerEl.hasAttribute('tabindex')) triggerEl.setAttribute('tabindex', '-1');
        triggerEl.focus({ preventScroll: true });
      }
      triggerEl = null;
    }

    var wasOpen = modal.classList.contains('open');
    if (wasOpen) onOpen();

    new MutationObserver(function () {
      var isOpen = modal.classList.contains('open');
      if (isOpen === wasOpen) return;
      wasOpen = isOpen;
      if (isOpen) onOpen();
      else onClose();
    }).observe(modal, { attributes: true, attributeFilter: ['class'] });
  }

  function boot() {
    document.querySelectorAll('.pl-video-modal').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
